import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import auth0Client from "../auth/Auth";

export default function PrivateRoute({ component, render, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          {auth0Client.isAuthenticated() ? (
            React.createElement(render || component, props)
          ) : (
            // eslint-disable-next-line react/prop-types
            <div>{auth0Client.checkSession()}</div>
          )}
        </>
      )}
    />
  );
}

PrivateRoute.defaultProps = {
  component: undefined,
};
PrivateRoute.propTypes = {
  component: PropTypes.node,
  render: PropTypes.func.isRequired,
};
